(function () {
  // -------------------------
  // CONFIG
  // -------------------------
  const LINE_SPACING_BASE = 1.2;
  const PX_TO_CM = 2.54 / 96;

  // ✅ pro zusätzlicher Zeile +1.5 cm Mindesthöhe
  const MIN_LINE_HEIGHT_CM = 1.5;

  const MAX_WIDTH_CM = 210;
  const MAX_HEIGHT_CM = 110;

  // ✅ max lines
  const MAX_LINES = 3;

  // baseFontSize wird aus #base_font_size geholt (z.B. 55/80)
  let BASE_FONT_SIZE = 80;

  // ✅ Produkt-Mindesthöhe aus #min_height (z.B. 15.0 cm)
  let MIN_HEIGHT_CM = 0;

  let FONT_CONFIG = {};
  let loadedFonts = {};
  let currentFontName = null;

  // lines: {id,text,fallbackText,fontName,color,colorLabel,sizePercent,align,spacing}
  let lines = [];
  let activeLineId = null;

  // SVG.js draw für Text
  let draw = null;

  // für cm scaling
  let desiredWidthCm = null;
  let desiredHeightCm = null;
  let lastEdited = null;
  let updatingInputs = false;

  // size input guard (damit sync nöd während tippe überschreibt)
  let sizeEditing = null;

  // Motiv px-masse (aus Hidden Inputs)
  let motifWidthPx = null;
  let motifHeightPx = null;

  // margin-top vom #text-preview (Gap Motiv -> Text)
  let baseTextMarginTopPx = 0;

  // ✅ wichtig: verhindert Style-"Leaking" bi Line-Wechsel
  let syncingPanel = false;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function uid() {
    return Date.now().toString() + Math.random().toString(16).slice(2);
  }

  function getLineById(id) {
    return lines.find((l) => l.id === id) || null;
  }

  function getLineIndexById(id) {
    return lines.findIndex((l) => l.id === id);
  }

  function safeFloat(v, fallback) {
    const n = parseFloat(String(v ?? "").replace(",", "."));
    return Number.isFinite(n) ? n : fallback;
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  // ✅ CM aus "15.0 cm" etc.
  function parseCmFromText(text) {
    if (!text) return null;
    const m = String(text).replace(",", ".").match(/[\d.]+/);
    return m ? parseFloat(m[0]) : null;
  }

  // ✅ spacing immer 1 Dezimal (damit "1.0" == Option "1.0")
  function normalizeSpacingNumber(v, fallback = 1.0) {
    const n = safeFloat(v, fallback);
    const clamped = clamp(n, 0.5, 2.5);
    return parseFloat(clamped.toFixed(1));
  }
  function formatSpacingString(v, fallback = 1.0) {
    return normalizeSpacingNumber(v, fallback).toFixed(1);
  }

  function normalizeFontName(name) {
    if (!name) return null;
    return String(name).split(",")[0].trim().replace(/^["']|["']$/g, "");
  }

  // initiale Font aus line-settings-panel (value > data-text > CSS)
  function getInitialFontFromPanel() {
    const panel = document.getElementById("line-settings-panel");
    if (!panel) return null;

    const el = panel.querySelector(".wunschtext-line-font-input");
    if (!el) return null;

    const v = (el.value || "").trim();
    if (v) return normalizeFontName(v);

    const dt = el.dataset && el.dataset.text ? String(el.dataset.text).trim() : "";
    if (dt) return normalizeFontName(dt);

    const dtAttr = String(el.getAttribute("data-text") || "").trim();
    if (dtAttr) return normalizeFontName(dtAttr);

    const fam = getComputedStyle(el).fontFamily;
    return normalizeFontName(fam);
  }

  // -------------------------
  // ✅ NEW: FARBNAME (LABEL) AUS DYNAMIC SELECT HOLEN
  // -------------------------
  function getColorLabelFromSelect(colorInput, valueHex) {
    if (!colorInput) return null;

    const root =
      colorInput.closest(".dynamic-select") ||
      colorInput.closest('[class*="dynamic-select"]') ||
      document;

    // 1) Header-Text (meistens de sichtbari Farbname)
    const headerText = root.querySelector(".dynamic-select-header .dynamic-select-option-text");
    if (headerText) {
      const t = (headerText.textContent || "").trim();
      if (t) return t;
    }

    // 2) Option via value finden und Option-Text lese
    const opt = findOptionForValue(root, "color", valueHex);
    const optWrap = opt ? opt.closest(".dynamic-select-option") || opt : null;
    if (optWrap) {
      const optText =
        optWrap.querySelector(".dynamic-select-option-text") ||
        (optWrap.classList.contains("dynamic-select-option-text") ? optWrap : null);

      const t = (optText ? optText.textContent : optWrap.textContent || "").trim();
      if (t) return t;
    }

    return null;
  }

  // -------------------------
  // MOTIV COLORS (1x oder mehrere Inputs)
  // -------------------------
  function escCssIdent(ident) {
    const s = String(ident || "");
    if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(s);
    return s.replace(/[^a-zA-Z0-9_-]/g, "\\$&");
  }

  function getColorFromMotifInput(inp) {
    if (!inp) return null;

    const cAttr = inp.getAttribute("color-value");
    if (cAttr && cAttr.trim()) return cAttr.trim();

    const v = (inp.value || "").trim();
    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v)) return v;

    return null;
  }

  // Extrahiert Ziel-Klasse aus name="properties[Motivfarbe: Feefarbe]"
  function getTargetClassFromMotifInput(inp) {
    if (!inp) return null;

    const name = String(inp.getAttribute("name") || "");
    const m = name.match(/Motivfarbe\s*:\s*([^\]]+)\]/i);
    if (m && m[1]) return m[1].trim();

    const dt = inp.getAttribute("data-motif-class");
    if (dt && dt.trim()) return dt.trim();

    return null;
  }

  function applyColorToMotif() {
    const inputs = Array.from(document.querySelectorAll(".motiv-color-input"));
    if (!inputs.length) return;

    const svgMotif =
      document.getElementById("svg-path") ||
      (document.querySelector(".svg-size") ? document.querySelector(".svg-size svg:not(#text-preview)") : null);

    if (!svgMotif) return;

    const SHAPES = "path, rect, circle, ellipse, polygon, polyline, line";

    // ✅ nur 1 Input -> alles einfärben
    if (inputs.length === 1) {
      const color = getColorFromMotifInput(inputs[0]);
      if (!color) return;

      svgMotif.querySelectorAll(SHAPES).forEach((el) => {
        el.setAttribute("fill", color);
        el.setAttribute("stroke", color);
      });
      return;
    }

    // ✅ mehrere Inputs -> nur passende Klassen einfärben
    inputs.forEach((inp) => {
      const color = getColorFromMotifInput(inp);
      const targetClass = getTargetClassFromMotifInput(inp);
      if (!color || !targetClass) return;

      const cls = escCssIdent(targetClass);
      const selector = SHAPES.split(",")
        .map((s) => `${s.trim()}.${cls}`)
        .join(", ");

      svgMotif.querySelectorAll(selector).forEach((el) => {
        el.setAttribute("fill", color);
        el.setAttribute("stroke", color);
      });
    });
  }

  // ✅ Add-Button Status updaten (max 3)
  function updateAddLineBtnState() {
    const addBtn = document.getElementById("add-line-btn");
    if (!addBtn) return;

    const full = lines.length >= MAX_LINES;

    addBtn.disabled = full;
    addBtn.style.opacity = full ? "0.5" : "";
    addBtn.style.cursor = full ? "not-allowed" : "";
    addBtn.style.pointerEvents = full ? "none" : "";
  }

  // -------------------------
  // INIT
  // -------------------------
  document.addEventListener("DOMContentLoaded", function () {
    const baseFontInput = document.getElementById("base_font_size");
    if (baseFontInput) {
      const v = safeFloat(baseFontInput.value, null);
      if (v && v > 0) BASE_FONT_SIZE = v;
    }

    const wIn = document.getElementById("svg_path_width");
    const hIn = document.getElementById("svg_path_height");
    if (wIn) motifWidthPx = safeFloat(wIn.value, null);
    if (hIn) motifHeightPx = safeFloat(hIn.value, null);

    // ✅ MIN_HEIGHT aus hidden input lesen
    const minHeightIn = document.getElementById("min_height");
    if (minHeightIn && minHeightIn.value) {
      const mh = parseCmFromText(minHeightIn.value);
      if (mh && mh > 0) MIN_HEIGHT_CM = mh;
    }

    // ✅ initial min attr setzen (wird in renderPreview dynamisch updated)
    const heightInput = document.getElementById("target-height-cm");
    if (heightInput && MIN_HEIGHT_CM > 0) {
      heightInput.min = MIN_HEIGHT_CM.toFixed(1);
    }

    const svgEl = document.getElementById("text-preview");
    if (!svgEl) {
      console.warn("[Wunschtext+Motiv] SVG #text-preview nicht gefunden.");
      return;
    }

    {
      const cs = getComputedStyle(svgEl);
      baseTextMarginTopPx = parseFloat(cs.marginTop) || 0;
    }

    draw = SVG(svgEl);

    initFontConfigAndLoad();
    initGlobalSizeControls();
    initDelegatedLineControls();
    initSettingsPanelListeners();
    initMotifColorListeners();

    // ✅ erste Zeile: immer Defaults (nid Panel-Style kopiere)
    addLine({
      text: "",
      sizePercent: 100,
      color: "#000000",
      align: "center",
      fontName: currentFontName,
      spacing: 1.0,
    });

    applyColorToMotif();
  });

  // -------------------------
  // FONTS
  // -------------------------
  function initFontConfigAndLoad() {
    const select = document.getElementById("font-select");
    if (!select) return;

    FONT_CONFIG = {};
    loadedFonts = {};

    Array.from(select.options).forEach((opt) => {
      const name = opt.value;
      const url = opt.dataset.font;
      if (name && url) FONT_CONFIG[name] = url;
    });

    const panelFont = getInitialFontFromPanel();
    if (panelFont && FONT_CONFIG[panelFont]) {
      currentFontName = panelFont;
      if (select.value !== panelFont) select.value = panelFont;
    } else {
      currentFontName = select.value || Object.keys(FONT_CONFIG)[0] || null;
    }

    Object.entries(FONT_CONFIG).forEach(([name, url]) => {
      opentype.load(url, function (err, font) {
        if (err) {
          console.error("[Wunschtext+Motiv] Font load error:", name, err);
          return;
        }
        loadedFonts[name] = font;
        renderPreview();
      });
    });
  }

  // -------------------------
  // SIZE INPUTS
  // -------------------------
  function initGlobalSizeControls() {
    const widthInput = document.getElementById("target-width-cm");
    const heightInput = document.getElementById("target-height-cm");

    function attach(input, kind) {
      if (!input) return;

      input.addEventListener("focus", () => {
        sizeEditing = kind;
      });
      input.addEventListener("blur", () => {
        sizeEditing = null;
      });

      ["change", "blur"].forEach((evt) => {
        input.addEventListener(evt, () => {
          if (updatingInputs) return;
          const v = safeFloat(input.value, null);

          if (kind === "width") {
            desiredWidthCm = v;
            lastEdited = "width";
          } else {
            desiredHeightCm = v;
            lastEdited = "height";
          }

          renderPreview();
        });
      });
    }

    attach(widthInput, "width");
    attach(heightInput, "height");

    $$(".size-step-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const targetKind = btn.dataset.target;
        const dir = btn.dataset.dir === "-" ? -1 : 1;
        const input = targetKind === "width" ? widthInput : heightInput;
        if (!input) return;

        const step = safeFloat(input.step, 0.1);
        let cur = safeFloat(input.value, 0);

        cur = cur + dir * step;
        if (input.min !== "") cur = Math.max(cur, safeFloat(input.min, cur));
        if (input.max !== "") cur = Math.min(cur, safeFloat(input.max, cur));

        input.value = cur.toFixed(1);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }

  // -------------------------
  // LINE UI
  // -------------------------
  function initDelegatedLineControls() {
    const addBtn = document.getElementById("add-line-btn");
    if (addBtn) {
      addBtn.addEventListener("click", function (e) {
        e.preventDefault();
        addLine(); // ✅ defaults
      });
    }

    document.addEventListener("click", function (e) {
      const removeBtn = e.target.closest(".wunschtext-line-remove");
      if (removeBtn) {
        e.preventDefault();
        const row = removeBtn.closest(".line-row, .line-control");
        if (!row) return;
        removeLine(row.dataset.lineId);
        return;
      }

      // ✅ DUPLICATE
      const dupBtn = e.target.closest(".duplicate-button");
      if (dupBtn) {
        e.preventDefault();
        const row = dupBtn.closest(".line-row, .line-control");
        if (!row) return;
        duplicateLine(row.dataset.lineId);
        return;
      }

      const row = e.target.closest(".line-row, .line-control");
      if (row && row.dataset.lineId) {
        setActiveLine(row.dataset.lineId);
      }
    });

    document.addEventListener("input", function (e) {
      const input = e.target.closest(".wunschtext-line-text");
      if (!input) return;

      const row = input.closest(".line-row, .line-control");
      if (!row) return;

      const line = getLineById(row.dataset.lineId);
      if (!line) return;

      line.text = input.value;
      renderPreview();
    });
  }

  function addLine(initial = {}) {
    if (lines.length >= MAX_LINES) {
      updateAddLineBtnState();
      return;
    }

    const id = uid();

    // ✅ defaults (nicht vom Panel kopiert)
    const line = {
      id,
      text: typeof initial.text === "string" ? initial.text : "",
      fallbackText: initial.fallbackText || "Wunschtext",
      fontName: initial.fontName || currentFontName || Object.keys(FONT_CONFIG)[0] || null,
      color: initial.color || "#000000",

      // ✅ NEW: Farbname fürs Hidden-Field (wird später updated)
      colorLabel: typeof initial.colorLabel === "string" ? initial.colorLabel : "",

      sizePercent: typeof initial.sizePercent === "number" ? initial.sizePercent : 100,
      align: initial.align || "center",
      spacing: normalizeSpacingNumber(initial.spacing, 1.0),
    };

    lines.push(line);
    renderLineRow(line);
    renumberPropertyNames();
    rebuildTabs();
    setActiveLine(id);
    renderPreview();
    updateAddLineBtnState();
  }

  function removeLine(lineId) {
    const idx = getLineIndexById(lineId);
    if (idx === -1) return;

    const row = document.querySelector(
      '.line-row[data-line-id="' + lineId + '"], .line-control[data-line-id="' + lineId + '"]'
    );
    if (row) row.remove();

    lines.splice(idx, 1);

    if (activeLineId === lineId) {
      const next = lines[idx] || lines[idx - 1] || lines[0] || null;
      activeLineId = next ? next.id : null;
    }

    renumberPropertyNames();
    rebuildTabs();
    if (activeLineId) syncPanelFromLine(getLineById(activeLineId));
    renderPreview();
    updateAddLineBtnState();
  }

  // ✅ DUPLICATE LINE (nur hier Style kopiere)
  function duplicateLine(lineId) {
    if (lines.length >= MAX_LINES) {
      updateAddLineBtnState();
      return;
    }

    const idx = getLineIndexById(lineId);
    if (idx === -1) return;

    const original = lines[idx];
    if (!original) return;

    const newId = uid();

    const copy = {
      id: newId,
      text: original.text || "",
      fallbackText: original.fallbackText || "Wunschtext",
      fontName: original.fontName,
      color: original.color,

      // ✅ NEW: Label mitkopiere
      colorLabel: original.colorLabel || "",

      sizePercent: original.sizePercent,
      align: original.align,
      spacing: normalizeSpacingNumber(original.spacing, 1.0),
    };

    lines.splice(idx + 1, 0, copy);

    const originalRow = document.querySelector(
      '.line-row[data-line-id="' + lineId + '"], .line-control[data-line-id="' + lineId + '"]'
    );
    renderLineRow(copy, originalRow);

    renumberPropertyNames();
    rebuildTabs();
    setActiveLine(newId);
    renderPreview();
    updateAddLineBtnState();
  }

  function renderLineRow(line, insertAfterEl = null) {
    const container = document.getElementById("lines-container");
    const template = document.getElementById("line-template");
    if (!container || !template) return;

    const fragment = template.content.cloneNode(true);
    const row = fragment.querySelector(".line-row, .line-control");
    if (!row) {
      console.warn("[Wunschtext+Motiv] line-template braucht .line-row oder .line-control als Wrapper.");
      return;
    }

    row.dataset.lineId = line.id;

    const textInput = row.querySelector(".wunschtext-line-text");
    if (textInput) {
      const fb =
        (textInput.dataset && textInput.dataset.text) ||
        textInput.getAttribute("data-text") ||
        textInput.getAttribute("placeholder") ||
        "Wunschtext";

      line.fallbackText = String(fb || "Wunschtext");
      textInput.value = line.text || "";
    }

    writeLineHiddenToRow(row, line);

    if (insertAfterEl && insertAfterEl.parentNode === container) {
      container.insertBefore(fragment, insertAfterEl.nextSibling);
    } else {
      container.appendChild(fragment);
    }
  }

  function writeLineHiddenToRow(row, line) {
    const font = row.querySelector(".line-prop-font");
    const col = row.querySelector(".line-prop-color");
    const size = row.querySelector(".line-prop-size");
    const spc = row.querySelector(".line-prop-spacing");
    const alg = row.querySelector(".line-prop-align");

    if (font) font.value = line.fontName || "";

    // ✅ Hidden bekommt Label (fallback: Hex)
    if (col) col.value = (line.colorLabel && line.colorLabel.trim()) ? line.colorLabel.trim() : line.color;

    if (size) size.value = String(line.sizePercent);
    if (spc) spc.value = formatSpacingString(line.spacing, 1.0); // ✅ "1.0" statt "1"
    if (alg) alg.value = line.align;
  }

  function renumberPropertyNames() {
    const rows = $$(".line-row, .line-control", document.getElementById("lines-container") || document);
    rows.forEach((row, i) => {
      const n = i + 1;

      const text = row.querySelector(".wunschtext-line-text");
      const font = row.querySelector(".line-prop-font");
      const col = row.querySelector(".line-prop-color");
      const size = row.querySelector(".line-prop-size");
      const spc = row.querySelector(".line-prop-spacing");
      const alg = row.querySelector(".line-prop-align");

      if (text) text.name = `properties[Text${n}]`;
      if (font) font.name = `properties[Schrifart${n}]`;
      if (col) col.name = `properties[Folienfarbe${n}]`;
      if (size) size.name = `properties[_Textgroesse${n}]`;
      if (spc) spc.name = `properties[_AbstandOben${n}]`;
      if (alg) alg.name = `properties[_Ausrichtung${n}]`;
    });
  }

  // -------------------------
  // TABS
  // -------------------------
  function rebuildTabs() {
    const tabs = document.getElementById("line-tabs");
    if (!tabs) return;

    tabs.innerHTML = "";

    lines.forEach((line, i) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "line-tab-btn";
      btn.dataset.lineId = line.id;
      btn.textContent = `Zeile ${i + 1}`;
      if (line.id === activeLineId) btn.classList.add("is-active");
      btn.addEventListener("click", () => setActiveLine(line.id));
      tabs.appendChild(btn);
    });

    updateAddLineBtnState();
  }

  function setActiveLine(lineId) {
    if (!lineId) return;
    activeLineId = lineId;

    $$(".line-row, .line-control").forEach((r) => r.classList.toggle("is-active", r.dataset.lineId === lineId));
    $$(".line-tab-btn").forEach((b) => b.classList.toggle("is-active", b.dataset.lineId === lineId));

    const line = getLineById(lineId);
    if (line) syncPanelFromLine(line);
  }

  // -------------------------
  // SETTINGS PANEL
  // -------------------------
  function initSettingsPanelListeners() {
    const panel = document.getElementById("line-settings-panel");
    if (!panel) return;

    if (window.initAllDynamicSelects) {
      window.initAllDynamicSelects(panel);
    }

    function applyPanelToActiveLine() {
      if (syncingPanel) return;
      if (!activeLineId) return;
      const line = getLineById(activeLineId);
      if (!line) return;

      const fontInput = panel.querySelector(".wunschtext-line-font-input");
      const colorInput = panel.querySelector(".wunschtext-line-color-input");
      const sizeInput = panel.querySelector(".wunschtext-line-size-input");
      const alignInput = panel.querySelector(".wunschtext-line-align-input");
      const spcInput = panel.querySelector(".wunschtext-line-spacing-input");

      if (fontInput) {
        const v = (fontInput.value || "").trim();
        const dt = fontInput.dataset && fontInput.dataset.text ? String(fontInput.dataset.text).trim() : "";
        const dtAttr = String(fontInput.getAttribute("data-text") || "").trim();
        const wanted = normalizeFontName(v || dt || dtAttr);

        if (wanted && (FONT_CONFIG[wanted] || loadedFonts[wanted])) line.fontName = wanted;
        else if (v) line.fontName = v;

        writeLineHidden(activeLineId, "font", line.fontName);
      }

      if (colorInput) {
        // ✅ Preview bleibt Hex/Value
        const c = colorInput.getAttribute("color-value") || colorInput.value || line.color;
        line.color = c;

        // ✅ Hidden = Farbname
        const label = getColorLabelFromSelect(colorInput, c);
        line.colorLabel = (label && label.trim()) ? label.trim() : c;

        writeLineHidden(activeLineId, "color", line.colorLabel);
      }

      if (sizeInput) {
        const v = safeFloat(sizeInput.value, line.sizePercent);
        line.sizePercent = v;
        writeLineHidden(activeLineId, "size", String(v));
      }

      if (alignInput) {
        line.align = alignInput.value || line.align;
        writeLineHidden(activeLineId, "align", line.align);
      }

      if (spcInput) {
        const vNum = normalizeSpacingNumber(spcInput.value, line.spacing);
        line.spacing = vNum;
        writeLineHidden(activeLineId, "spacing", formatSpacingString(vNum, 1.0)); // ✅ "1.0"
      }

      renderPreview();
    }

    // ✅ nur echte User-Änderige
    panel.addEventListener("change", () => {
      applyPanelToActiveLine();
    });

    // ✅ falls dynamic-select kei change feuert: nur uf Option-Click reagierä
    panel.addEventListener("click", (e) => {
      if (syncingPanel) return;
      const opt = e.target.closest(".dynamic-select-option");
      if (!opt) return;
      setTimeout(() => applyPanelToActiveLine(), 0);
    });
  }

  function syncPanelFromLine(line) {
    const panel = document.getElementById("line-settings-panel");
    if (!panel || !line) return;

    const fontInput = panel.querySelector(".wunschtext-line-font-input");
    const colorInput = panel.querySelector(".wunschtext-line-color-input");
    const sizeInput = panel.querySelector(".wunschtext-line-size-input");
    const alignInput = panel.querySelector(".wunschtext-line-align-input");
    const spcInput = panel.querySelector(".wunschtext-line-spacing-input");

    syncingPanel = true;
    setPanelValue(panel, fontInput, line.fontName || "", "font");
    setPanelValue(panel, colorInput, line.color, "color");
    setPanelValue(panel, sizeInput, String(line.sizePercent), "size");
    setPanelValue(panel, alignInput, line.align, "align");
    setPanelValue(panel, spcInput, formatSpacingString(line.spacing, 1.0), "spacing"); // ✅ immer "x.x"
    syncingPanel = false;

    // ✅ Hidden korrekt halten (Name)
    if (colorInput) {
      const label = getColorLabelFromSelect(colorInput, line.color);
      line.colorLabel = (label && label.trim()) ? label.trim() : (line.colorLabel || line.color);
      writeLineHidden(line.id, "color", line.colorLabel);
    }
  }

  // -------------------------
  // Dynamic-Select Helpers
  // -------------------------
  function cssEscapeAttr(value) {
    const s = String(value ?? "");
    if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(s);
    return s.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  }

  function findOptionForValue(root, kind, value) {
    if (!root) return null;

    const v = String(value ?? "");
    const esc = cssEscapeAttr(v);

    // 1) direkter Match
    let opt =
      root.querySelector(`.dynamic-select-option[data-value="${esc}"]`) ||
      root.querySelector(`.dynamic-select-option[value="${esc}"]`) ||
      root.querySelector(`.dynamic-select-option[color-value="${esc}"]`) ||
      root.querySelector(`.dynamic-select-option[option-value="${esc}"]`) ||
      root.querySelector(`[data-value="${esc}"]`) ||
      root.querySelector(`[value="${esc}"]`) ||
      root.querySelector(`[color-value="${esc}"]`) ||
      root.querySelector(`[option-value="${esc}"]`);

    if (opt) return opt.closest(".dynamic-select-option") || opt;

    // 2) numeric fallback (vor allem für spacing)
    const vNum = parseFloat(v.replace(",", "."));
    if (Number.isFinite(vNum)) {
      const opts = Array.from(root.querySelectorAll(".dynamic-select-option"));
      const hit = opts.find((o) => {
        const dv = o.getAttribute("data-value") ?? o.getAttribute("value") ?? o.getAttribute("option-value") ?? "";
        const n = parseFloat(String(dv).replace(",", "."));
        return Number.isFinite(n) && Math.abs(n - vNum) < 0.00001;
      });
      if (hit) return hit;
    }

    return null;
  }

  function copyColorStyles(fromEl, toEl) {
    if (!toEl) return;

    if (!fromEl) {
      toEl.style.backgroundColor = "";
      toEl.style.color = "";
      return;
    }

    const cs = getComputedStyle(fromEl);
    const bg = fromEl.style.backgroundColor || cs.backgroundColor;
    const fg = fromEl.style.color || cs.color;

    toEl.style.backgroundColor = bg && bg !== "rgba(0, 0, 0, 0)" ? bg : "";
    toEl.style.color = fg ? fg : "";
  }

  // ✅ Panel setzen OHNE click/change-Events (sonst überschreibt es Zeilen)
  function setPanelValue(panel, input, value, kind) {
    if (!panel || !input) return;

    try {
      input.value = value;
    } catch (_) {}

    if (kind === "color") input.setAttribute("color-value", value);

    const root = input.closest(".dynamic-select") || input.closest('[class*="dynamic-select"]') || panel;

    const opt = findOptionForValue(root, kind, value);
    const optWrap = opt ? opt.closest(".dynamic-select-option") || opt : null;

    const allOpts = root.querySelectorAll(".dynamic-select-option");
    allOpts.forEach((o) => o.classList.remove("dynamic-select-selected"));
    if (optWrap) optWrap.classList.add("dynamic-select-selected");

    const headerText = root.querySelector(".dynamic-select-header .dynamic-select-option-text");
    if (!headerText) return;

    const optTextEl =
      (optWrap && optWrap.querySelector(".dynamic-select-option-text")) ||
      (opt && opt.classList && opt.classList.contains("dynamic-select-option-text") ? opt : null);

    headerText.textContent = optTextEl ? optTextEl.textContent.trim() : String(value);

    if (kind === "color") {
      if (optTextEl) {
        copyColorStyles(optTextEl, headerText);
        if (optTextEl.dataset && optTextEl.dataset.textColor) {
          headerText.dataset.textColor = optTextEl.dataset.textColor;
        }
      } else {
        if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(String(value))) {
          headerText.style.backgroundColor = String(value);
        } else {
          headerText.style.backgroundColor = "";
        }
        headerText.style.color = "";
      }
    }
  }

  function writeLineHidden(lineId, kind, value) {
    const row = document.querySelector(
      '.line-row[data-line-id="' + lineId + '"], .line-control[data-line-id="' + lineId + '"]'
    );
    if (!row) return;

    if (kind === "font") {
      const el = row.querySelector(".line-prop-font");
      if (el) el.value = value;
    }
    if (kind === "color") {
      const el = row.querySelector(".line-prop-color");
      if (el) el.value = value;
    }
    if (kind === "size") {
      const el = row.querySelector(".line-prop-size");
      if (el) el.value = value;
    }
    if (kind === "spacing") {
      const el = row.querySelector(".line-prop-spacing");
      if (el) el.value = formatSpacingString(value, 1.0);
    }
    if (kind === "align") {
      const el = row.querySelector(".line-prop-align");
      if (el) el.value = value;
    }
  }

  // -------------------------
  // MOTIV COLOR LISTENERS
  // -------------------------
  function initMotifColorListeners() {
    document.addEventListener("change", (e) => {
      const t = e.target;
      if (t && t.classList && t.classList.contains("motiv-color-input")) {
        applyColorToMotif();
      }
    });

    document.addEventListener("input", (e) => {
      const t = e.target;
      if (t && t.classList && t.classList.contains("motiv-color-input")) {
        applyColorToMotif();
      }
    });

    applyColorToMotif();
  }

  // -------------------------
  // PREVIEW RENDER (Text + Motiv)
  // -------------------------
  function transformPath(path, scale, dx, dy) {
    const commands = path.commands || [];
    commands.forEach((cmd) => {
      if ("x" in cmd) cmd.x = cmd.x * scale + dx;
      if ("y" in cmd) cmd.y = cmd.y * scale + dy;
      if ("x1" in cmd) cmd.x1 = cmd.x1 * scale + dx;
      if ("y1" in cmd) cmd.y1 = cmd.y1 * scale + dy;
      if ("x2" in cmd) cmd.x2 = cmd.x2 * scale + dx;
      if ("y2" in cmd) cmd.y2 = cmd.y2 * scale + dy;
    });
  }

  function renderPreview() {
    if (!draw) return;
    draw.clear();

    if (!lines.length) {
      draw.viewbox(0, 0, 10, 10);
      updateSizeInfo(null, null);
      return;
    }

    const tempEntries = [];
    let maxWidth = 0;

    lines.forEach((line) => {
      const t = line.text && line.text.trim().length ? line.text : line.fallbackText || "Wunschtext";
      const text = t || " ";

      const fontName = line.fontName || currentFontName;
      const font = loadedFonts[fontName];
      if (!font) return;

      const sizePercent = typeof line.sizePercent === "number" ? line.sizePercent : 100;
      const fontSize = BASE_FONT_SIZE * (sizePercent / 100);

      const path = font.getPath(text, 0, 0, fontSize);
      const bb = path.getBoundingBox();
      const lineHeightPx = bb.y2 - bb.y1 || fontSize;

      maxWidth = Math.max(maxWidth, bb.x2 - bb.x1);

      tempEntries.push({
        path,
        bb,
        lineHeightPx,
        color: line.color || "#000000",
        align: line.align || "center",
        spacing: normalizeSpacingNumber(line.spacing, 1.0),
      });
    });

    if (!tempEntries.length || maxWidth <= 0) {
      draw.viewbox(0, 0, 10, 10);
      updateSizeInfo(null, null);
      return;
    }

    const pathEntries = [];
    let currentY = 0;
    let prevLineHeightPx = 0;

    const refLeft = 0;
    const refRight = maxWidth;
    const refCenter = maxWidth / 2;

    tempEntries.forEach((entry, index) => {
      const { path, bb, lineHeightPx, color, align, spacing } = entry;

      if (index === 0) currentY = 0;
      else currentY += prevLineHeightPx * LINE_SPACING_BASE * (spacing || 1);

      prevLineHeightPx = lineHeightPx;

      const lineLeft = bb.x1;
      const lineRight = bb.x2;
      const lineCenter = (bb.x1 + bb.x2) / 2;

      let shiftX = 0;
      if (align === "left") shiftX = refLeft - lineLeft;
      else if (align === "right") shiftX = refRight - lineRight;
      else shiftX = refCenter - lineCenter;

      const shiftY = currentY - bb.y1;

      (path.commands || []).forEach((cmd) => {
        if ("x" in cmd) cmd.x += shiftX;
        if ("y" in cmd) cmd.y += shiftY;
        if ("x1" in cmd) cmd.x1 += shiftX;
        if ("y1" in cmd) cmd.y1 += shiftY;
        if ("x2" in cmd) cmd.x2 += shiftX;
        if ("y2" in cmd) cmd.y2 += shiftY;
      });

      pathEntries.push({ path, color });
    });

    let minX = Infinity,
      minY = Infinity,
      maxX = -Infinity,
      maxY = -Infinity;
    pathEntries.forEach((entry) => {
      const bb = entry.path.getBoundingBox();
      minX = Math.min(minX, bb.x1);
      minY = Math.min(minY, bb.y1);
      maxX = Math.max(maxX, bb.x2);
      maxY = Math.max(maxY, bb.y2);
    });

    const rawTextWidthPx = maxX - minX;
    const rawTextHeightPx = maxY - minY;

    const firstLine = lines[0] || null;
    const firstEntry = tempEntries[0] || null;
    let extraGapPx = 0;
    if (firstLine && firstEntry) {
      const spacingFactor = normalizeSpacingNumber(firstLine.spacing, 1.0);
      extraGapPx = (spacingFactor - 1) * firstEntry.lineHeightPx;
      if (!isFinite(extraGapPx)) extraGapPx = 0;
    }
    const rawGapPx = Math.max(0, baseTextMarginTopPx + extraGapPx);

    const rawMotifW = motifWidthPx || 0;
    const rawMotifH = motifHeightPx || 0;

    const combinedRawWidthPx = Math.max(rawMotifW, rawTextWidthPx);
    const combinedRawHeightPx = rawMotifH + rawGapPx + rawTextHeightPx;

    let rawWidthCm = combinedRawWidthPx * PX_TO_CM;
    let rawHeightCm = combinedRawHeightPx * PX_TO_CM;

    if (!(rawWidthCm > 0 && rawHeightCm > 0)) {
      updateSizeInfo(null, null);
    } else {
      let scale = 1;

      if (lastEdited === "width" && desiredWidthCm && desiredWidthCm > 0) scale = desiredWidthCm / rawWidthCm;
      else if (lastEdited === "height" && desiredHeightCm && desiredHeightCm > 0) scale = desiredHeightCm / rawHeightCm;
      else if (desiredWidthCm && desiredWidthCm > 0) scale = desiredWidthCm / rawWidthCm;
      else if (desiredHeightCm && desiredHeightCm > 0) scale = desiredHeightCm / rawHeightCm;

      // ✅ Mindesthöhe:
      // - Produktbasis: MIN_HEIGHT_CM (z.B. 15)
      // - pro zusätzlicher Zeile: +1.5cm (Zeile2 +1.5, Zeile3 +3.0)
      const extraLines = Math.max(0, (lines.length || 1) - 1);
      const minTotalHeightCm = (MIN_HEIGHT_CM > 0 ? MIN_HEIGHT_CM : 0) + (extraLines * MIN_LINE_HEIGHT_CM);

      // ✅ Scale so, dass Gesamthöhe minTotalHeightCm erreicht
      const minScaleTotal = (minTotalHeightCm > 0) ? (minTotalHeightCm / rawHeightCm) : 0;

      // (optional) Text-Only Mindesthöhe (bleibt als Safety)
      const minTextOnlyCm = (lines.length || 1) * MIN_LINE_HEIGHT_CM;
      const minScaleTextOnly = (minTextOnlyCm > 0 && rawTextHeightPx > 0)
        ? (minTextOnlyCm / (rawTextHeightPx * PX_TO_CM))
        : 0;

      const minScale = Math.max(minScaleTotal, minScaleTextOnly);

      const maxScale = Math.min(MAX_WIDTH_CM / rawWidthCm, MAX_HEIGHT_CM / rawHeightCm);

      if (!isFinite(scale) || scale <= 0) scale = 1;
      if (scale < minScale) scale = minScale;
      if (scale > maxScale) scale = maxScale;

      const finalWidthCm = rawWidthCm * scale;
      const finalHeightCm = rawHeightCm * scale;

      // ✅ UI-min für Height dynamisch (damit Plus/Minus & Validierung passt)
      const heightInput = document.getElementById("target-height-cm");
      if (heightInput && minTotalHeightCm > 0) {
        heightInput.min = minTotalHeightCm.toFixed(1);
      }

      syncSizeInputs(finalWidthCm, finalHeightCm);
      updateSizeInfo(finalWidthCm, finalHeightCm);
    }

    const PREVIEW_MAX_W = 400;
    const PREVIEW_MAX_H = 600;

    let previewScale = 1;
    if (combinedRawWidthPx > 0 && combinedRawHeightPx > 0) {
      previewScale = Math.min(PREVIEW_MAX_W / combinedRawWidthPx, PREVIEW_MAX_H / combinedRawHeightPx, 1);
    }

    const offsetX = -(minX * previewScale);
    const offsetY = -(minY * previewScale);

    const group = draw.group();
    pathEntries.forEach((entry) => {
      transformPath(entry.path, previewScale, offsetX, offsetY);
      group.path(entry.path.toPathData(2)).fill(entry.color || "#000000");
    });

    const widthScaledText = rawTextWidthPx * previewScale;
    const heightScaledText = rawTextHeightPx * previewScale;

    draw.viewbox(0, 0, widthScaledText, heightScaledText);

    const textSvg = document.getElementById("text-preview");
    if (textSvg) {
      textSvg.setAttribute("width", widthScaledText);
      textSvg.setAttribute("height", heightScaledText);

      const newMargin = (baseTextMarginTopPx + extraGapPx) * previewScale;
      textSvg.style.marginTop = newMargin.toFixed(1) + "px";
    }

    const svgMotif =
      document.getElementById("svg-path") ||
      (document.querySelector(".svg-size") ? document.querySelector(".svg-size svg:not(#text-preview)") : null);

    if (svgMotif && motifWidthPx && motifHeightPx) {
      const scaledW = motifWidthPx * previewScale;
      const scaledH = motifHeightPx * previewScale;

      svgMotif.setAttribute("width", scaledW);
      svgMotif.setAttribute("height", scaledH);
      svgMotif.style.width = scaledW + "px";
      svgMotif.style.height = scaledH + "px";
    }

    applyColorToMotif();
  }

  function syncSizeInputs(wCm, hCm) {
    const widthInput = document.getElementById("target-width-cm");
    const heightInput = document.getElementById("target-height-cm");
    if (!widthInput || !heightInput || !wCm || !hCm) return;

    if (sizeEditing === "width" || sizeEditing === "height") return;

    updatingInputs = true;
    widthInput.value = wCm.toFixed(1);
    heightInput.value = hCm.toFixed(1);
    desiredWidthCm = wCm;
    desiredHeightCm = hCm;
    updatingInputs = false;
  }

  function updateSizeInfo(wCm, hCm) {
    const el = document.getElementById("size-info");
    if (!el) return;
    if (!wCm || !hCm) {
      el.textContent = "–";
      return;
    }
    el.textContent = wCm.toFixed(1) + " × " + hCm.toFixed(1) + " cm";
  }
})();
